export default __webpack_public_path__ + "static/media/nz-harbour-society-so-auckland.174515b6.jpg";